export default "__VITE_PUBLIC_ASSET__169c2dc4__"